// extracted by mini-css-extract-plugin
export var flagIconStyle = "svg_flag_icon-module--flagIconStyle--qkK85";
export var marginRightStyle = "svg_flag_icon-module--marginRightStyle--dyzpH";